import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href", "target", "rel"]
const _hoisted_2 = { class: "btn-inner" }
const _hoisted_3 = { class: "btn-inner" }


import IconTriangle from '@/components/icon/IconTriangle.vue'

interface Props {
  color?: string
  href: string
  blank?: boolean
  text: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BtnBase',
  props: {
    color: {},
    href: {},
    blank: { type: Boolean },
    text: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['btn', props.color ? `-${props.color}` : ''])
  }, [
    (props.blank)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: props.href,
          target: props.blank ? '_blank' : '_self',
          rel: props.blank ? 'noopener noreferrer' : ''
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(props.text) + " ", 1),
            _createVNode(IconTriangle)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg" }, null, -1))
        ], 8, _hoisted_1))
      : (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          to: props.href
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(props.text) + " ", 1),
              _createVNode(IconTriangle)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg" }, null, -1))
          ]),
          _: 1
        }, 8, ["to"]))
  ], 2))
}
}

})